import { Space, API, slugifyName } from "@thenounproject/lingo-core";
import { SearchFilterPreset } from "../types";
import { createQueryAction } from "@actions/actionCreators";

type Data = SearchFilterPreset[];
type Args = { spaceId: Space["id"] };

const [useAssetLibraryPresets, fetchAssetLibraryPresets] = createQueryAction<Args, Data>(
  {
    entity: "search",
    action: "fetchAssetLibraryPresets",
    denormalize: false,
  },
  async ({ args }) => {
    const res = await API.call<{ presets: Data }>({
      endpoint: `search/spaces/${args.spaceId}/presets?context=library`,
      method: "GET",
    });
    return {
      ...res,
      result: res.result.presets.map(preset => ({
        id: slugifyName(preset.name).toLowerCase(),
        ...preset,
      })),
    };
  }
);

export default useAssetLibraryPresets;
export { fetchAssetLibraryPresets };
